/*
 * An object containing properties for a notification type
 */
export class NotificationType {
  /**
   * Danger notification type
   */
  static readonly DANGER: string = 'danger';

  /**
   * Information notification type
   */
  static readonly INFO: string = 'info';

  /**
   * Success notification type
   */
  static readonly SUCCESS: string = 'success';

  /**
   * Warning notification type
   */
  static readonly WARNING: string = 'warning';
}
